import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M20.823 6.36H4.804a.5.5 0 0 0-.5.5v12.185a.5.5 0 0 0 .5.5h16.02a.5.5 0 0 0 .5-.5V6.861a.5.5 0 0 0-.5-.5ZM4.804 4.86a2 2 0 0 0-2 2v12.185a2 2 0 0 0 2 2h16.02a2 2 0 0 0 2-2V6.861a2 2 0 0 0-2-2H4.803Z" /> <path fill-rule="evenodd" clip-rule="evenodd" d="M21.479 10.56H4.199v-1.5h17.28v1.5ZM11.214 16.203a.75.75 0 0 1-.75.75h-2.5a.75.75 0 1 1 0-1.5h2.5a.75.75 0 0 1 .75.75Z" />' }
  })
);